import { styled } from "@mui/material/styles";

export const Line = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(4),
  height: "0.0625rem",
  width: "100%",
  background: theme.palette.custom?.grey?.border,
}));
